var m = require('mithril');
var moment = require('moment-timezone');
import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentPlugin from '@fullcalendar/moment';
import rrulePlugin from '@fullcalendar/rrule';

const component = {};

function initCalendar(el, parentCtrl) {
  if (!parentCtrl) return;
  if (parentCtrl.weeklyCalendar) return; // already initialized
  const calendar = parentCtrl.weeklyCalendar = new Calendar(el, {
    plugins: [ interactionPlugin, timeGridPlugin, rrulePlugin, momentPlugin ],
    schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
    disableMobile: true,
    defaultView: 'timeGridWeek',
    timeZone: 'local',
    eventOverlap: false,
    allDaySlot: false,
    titleFormat: 'dddd',
    header: { left: null, center: null, right: null },
    columnHeaderFormat: { weekday: 'short' },
    events: function (fetchInfo, successCallback, failureCallback) {
      let evs;
      try {
        evs = (typeof parentCtrl.value === 'function') ? parentCtrl.value() : parentCtrl.value;
        if (typeof evs === 'string') {
          try { evs = JSON.parse(evs); } catch (e) { evs = []; }
        }
      } catch (e) { evs = []; }
        if (!Array.isArray(evs)) evs = [];
        successCallback(evs);
    },
    dateClick: function(info) {
      if (typeof parentCtrl.addEvent === 'function') parentCtrl.addEvent.call(parentCtrl, calendar, info);
    },
    eventClick: function (info) {
      if (typeof parentCtrl.editEvent === 'function') parentCtrl.editEvent.call(parentCtrl, calendar, info);
    }
  });
  calendar.render();
}

component.view = function () {
  // Support both signatures: view(vnode) and view(ctrl, parentCtrl)
  let vnode, parentCtrl;
  if (arguments.length >= 2) {
    vnode = arguments[0];
    parentCtrl = arguments[1];
  } else {
    vnode = arguments[0];
    const attrs = vnode && vnode.attrs ? vnode.attrs : {};
    parentCtrl = attrs.parentCtrl || attrs;
  }
  return m('div.container.mb2.pb4', {
    style: { minHeight: '600px' },
    oncreate: function (vn) { initCalendar(vn.dom, parentCtrl); },
    onbeforeupdate: function () { return false; } // prevent Mithril from touching FullCalendar DOM
  })
}

export default component;
